import { render, staticRenderFns } from "./NegotiationBoticario.vue?vue&type=template&id=28cc0ae4&scoped=true"
import script from "./NegotiationBoticario.vue?vue&type=script&lang=js"
export * from "./NegotiationBoticario.vue?vue&type=script&lang=js"
import style0 from "./NegotiationBoticario.vue?vue&type=style&index=0&id=28cc0ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc0ae4",
  null
  
)

export default component.exports